/**
 * 表紙特集掲載商品選定（CX）画面の集計クラス
 *
 * @export TotallingInfo
 * @class TotallingInfo
 */
export class TotallingInfo {
  public check = false;
  constructor(
    // 部門
    public className: string = "",
    // 農産
    public farmProduct: string = "0",
    // 水産
    public marineProduct: string = "0",
    // 畜産
    public animalProduct: string = "0",
    // 日配
    public dailyDelivery: string = "0",
    // 菓子
    public sweets: string = "0",
    // 食品
    public food: string = "0",
    // 住関連
    public liveCategory: string = "0",
    // 加工肉
    public processedMeat: string = "0",
    // パン生菓子
    public bread: string = "0",
    // 酒
    public alcohol: string = "0",
    // 米
    public rice: string = "0",
    // たまご・牛乳
    public eggAndMilk: string = "0",
    // 冷食・アイス
    public freezedAndIce: string = "0",
    // 惣菜
    public deliFoods: string = "0",
  ) {}
}
